import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Footer = styled(Box)(({ theme }) => ({
  background: "white",
  zIndex: 2,
  width: "calc(100% - 16px)",
  maxWidth: "100%",
  padding: theme.spacing(3),
  paddingTop: 0,
  position: "fixed",
  boxSizing: "border-box",
  left: 0,
  bottom: 0,
}));
